import React from "react";
import { Alert, Spinner } from "react-bootstrap";

// Shared in-widget status box for the playground widgets. Every status is a
// standard react-bootstrap <Alert>, so they all share identical dimensions and
// differ only by variant color — no bespoke sizing that reads as inconsistent.
//
// Two families, distinguished purely by variant:
//   - "general widget alerts" — the widget cannot render its content yet
//     (nothing bound, no session, not available, loading, wrong type, load
//     error). Use info / warning; loading uses primary.
//   - "content-internal" — the widget is working; the notice is about the
//     content (empty content, a per-field/per-item note). Use the lowest-weight
//     "light" variant (a subtle neutral alert). A content-level error keeps
//     "warning".
//
// Props:
//   variant   - "light" (content-internal) | "info" | "warning" | "primary" |
//               "success" | "danger"
//   loading   - when true, prepend a small inline spinner
//   className - extra classes for the caller's own context — spacing utilities, and nothing else.
//               A status box that has to sit in a list with the rest of the list's gutter under it
//               is a placement question, which belongs to the list rather than to this component;
//               anything about how the box itself LOOKS still belongs here, so every one of them
//               keeps the same size and weight.
//   children  - the message (string or node)
export default function WidgetStatus({ variant = "info", loading = false, className = "", children }) {
  const loadingClass = loading ? " playground-widget-status-loading" : "";
  const extra = className ? ` ${className}` : "";
  return (
    <Alert variant={variant}
      className={`playground-widget-status playground-widget-status-alert${loadingClass}${extra}`}>
      {loading &&
        <Spinner animation="border" size="sm" className="playground-widget-status-spinner" />
      }
      <span className="playground-widget-status-message">{children}</span>
    </Alert>
  );
}
